import { notification } from "antd";
import { useEffect, useMemo, useState } from "react";
import { getApiError, getMarketInfo } from "tm-shared/api";
import { Market } from "tm-shared/types";

import { useAppSelector } from "@/hooks/redux";

interface UseMarketReturn {
    market: Market | null;
    marketLoading: boolean;
}

export const useMarket = (marketId: string): UseMarketReturn => {
    const { markets } = useAppSelector((state) => state.work);

    const storeMarket = useMemo(
        () => markets[marketId] ?? null,
        [markets, marketId],
    );

    const [market, setMarket] = useState<Market | null>(storeMarket);
    const [marketLoading, setMarketLoading] = useState(!storeMarket);

    useEffect(() => {
        setMarket(storeMarket);
        setMarketLoading(!storeMarket);
    }, [storeMarket]);

    useEffect(() => {
        let cancelled = false;

        const fetchMarket = async () => {
            if (storeMarket) return;

            try {
                setMarketLoading(true);

                const { result } = await getMarketInfo({ marketId });

                if (!cancelled) {
                    setMarket(result);
                }
            } catch (error) {
                if (!cancelled) {
                    const { displayMessage } = getApiError(error);

                    notification.error({
                        message: "Не вдалося завантажити маркет",
                        description: displayMessage,
                    });
                }
            } finally {
                if (!cancelled) {
                    setMarketLoading(false);
                }
            }
        };

        fetchMarket();

        return () => {
            cancelled = true;
        };
    }, [marketId, storeMarket]);

    return { market, marketLoading };
};
